export const PAYROLL_EXPORTS_SET = 'PAYROLL_EXPORTS_SET';
export const PAYROLL_EXPORT_REMOVE = 'PAYROLL_EXPORTS_REMOVE';

// PAYLOAD
export const PAYROLL_EXPORTS_PAYLOAD_REQUESTED =
    'PAYROLL_EXPORTS_PAYLOAD_REQUESTED';
export const PAYROLL_EXPORTS_PAYLOAD_SUCCEEDED =
    'PAYROLL_EXPORTS_PAYLOAD_SUCCEEDED';
export const PAYROLL_EXPORTS_PAYLOAD_FAILED = 'PAYROLL_EXPORTS_PAYLOAD_FAILED';

// DELETE
export const PAYROLL_EXPORT_DELETE_REQUESTED =
    'PAYROLL_EXPORT_DELETE_REQUESTED';
export const PAYROLL_EXPORT_DELETE_SUCCEEDED =
    'PAYROLL_EXPORT_DELETE_SUCCEEDED';
export const PAYROLL_EXPORT_DELETE_FAILED = 'PAYROLL_EXPORT_DELETE_FAILED';
